const SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

const Recaptcha = {
    /**
     * 
     * @param {string} action 
     * 
     * @returns {Promise<string>}
     */
    execute: (action) => {
        return new Promise((resolve, reject) => {
            if (window && window.grecaptcha) {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(SITE_KEY, {action: action}).then(function(token) {
                        resolve(token);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            } else {
                reject(new Error('There was a problem loading the Recaptcha script.'));
            }
        });
    },
};

export default Recaptcha;
